import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {SafeUrl} from '@angular/platform-browser';
import {CmsComponentData} from '@spartacus/storefront';
import {Observable} from 'rxjs';

import {AimoCMSTextBannerComponent} from '../../../model/cms.model';
import {SafeUrlPipe} from '../utils/safe-html/aimo-pipes';
import {AimoGtmService} from "../../../service/gtm/aimo-gtm.service";

@Component({
    selector: 'aimo-text-banner',
    templateUrl: './aimo-text-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AimoTextBannerComponent implements OnInit {
    data$: Observable<AimoCMSTextBannerComponent>;

    constructor(
        protected componentData: CmsComponentData<AimoCMSTextBannerComponent>,
        public safeUrlPipe: SafeUrlPipe,
        protected gtmService: AimoGtmService,
    ) {
    }

    ngOnInit(): void {
        this.data$ = this.componentData.data$;
    }

    isExternal(data: AimoCMSTextBannerComponent): boolean | null {
        return data?.external === 'true' || data?.external === true;
    }

    getTarget(data: AimoCMSTextBannerComponent): string | null {
        return this.isExternal(data) ? '_blank' : null;
    }

    getSafeUrl(data: AimoCMSTextBannerComponent): SafeUrl {
        return this.safeUrlPipe.transform(data.urlLink);
    }

    getBgClass(data: AimoCMSTextBannerComponent): string {
        return 'bg-' + data?.backgroundColor?.toLowerCase().replace('_', '-');
    }

    protected gtmEvent(data: AimoCMSTextBannerComponent): void {
        this.gtmService.pushEvent('info_banner_click')
    }
}
